import { createAction } from '@reduxjs/toolkit';
import { LoginResponse } from './auth.types';

export const logout = createAction('LOGOUT');

export const refreshTokens = createAction<LoginResponse>('REFRESH_TOKENS');
